import React from 'react';
import { Grid, Typography } from '@mui/material';

interface ReferralUsageHeaderProps {
  title?: string;
  subtitle?: string;
}

const ReferralUsageHeader: React.FC<ReferralUsageHeaderProps> = ({
  title = 'Referral Usage',
  subtitle = 'Monitor and manage referral code usages'
}) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          {title}
        </Typography>
        <Typography variant="subtitle2">{subtitle}</Typography>
      </Grid>
    </Grid>
  );
};

export default ReferralUsageHeader;
